/* eslint-disable max-len */

import SvgIcon from '@material-ui/core/SvgIcon';

const PositionIcon = ({ fontSize = 'inherit', fill = '#192A3E' }) => (
  <SvgIcon fontSize={ fontSize } viewBox="0 0 22 20">
<path d="m10.85 6.4414 5.4237 3.1356v6.2712l-5.4237 3.1356-5.4237-3.1356v-6.2712l5.4237-3.1356zm0 1.5098-4.118 2.3807v4.7614l4.118 2.3807 4.118-2.3807v-4.7614l-4.118-2.3807z" clipRule="evenodd" fill={ fill } fillRule="evenodd" />
<path d="m15.931 10.621-5.0848 2.9386-5.0847-2.9386 0.65128-1.1292 4.4334 2.5622 4.4335-2.5622 0.6513 1.1292z" clipRule="evenodd" fill={ fill } fillRule="evenodd" />
<path d="m20.68 18.984-5.4264-2.962 0.6753-1.1058 5.4264 2.962-0.6753 1.1058z" clipRule="evenodd" fill={ fill } fillRule="evenodd" />
<path d="m6.4415 16.007-5.4375 2.9769-0.66419-1.0909 5.4375-2.9769 0.66419 1.0909z" clipRule="evenodd" fill={ fill } fillRule="evenodd" />
<path d="m10.172 18.306v-5.4237h1.3559v5.4237h-1.3559z" clipRule="evenodd" fill={ fill } fillRule="evenodd" />
<path d="m10.849 0 2.7118 2.7856-0.9182 0.9432-1.7936-1.8424-1.7936 1.8424-0.91823-0.9432 2.7119-2.7856z" clipRule="evenodd" fill={ fill } fillRule="evenodd" />
<path d="m10.168 7.1193v-6.1017h1.3559v6.1017h-1.3559z" clipRule="evenodd" fill={ fill } fillRule="evenodd" />
<path d="m1.4188 18.138 0.46149-2.6162-1.1826-0.2676-0.69774 3.9555 3.4926 0.7903 0.23625-1.3394-2.31-0.5226z" clipRule="evenodd" fill={ fill } fillRule="evenodd" />
<path d="m20.936 15.254 0.7611 3.9555-3.8101 0.7903-0.2577-1.3394 2.52-0.5226-0.5034-2.6162 1.2901-0.2676z" clipRule="evenodd" fill={ fill } fillRule="evenodd" />
</SvgIcon>
);

export default PositionIcon;
